document.addEventListener("DOMContentLoaded", () => {
  const etPostMetaWrapper = document.querySelector('.et_post_meta_wrapper');

  if(etPostMetaWrapper) {
    const commentsCount = document.querySelector('.comments-number');
    const published = document.querySelector('.published');

    etPostMetaWrapper.appendChild(commentsCount);
    etPostMetaWrapper.prepend(published);
  }
});


// WEBPACK FOOTER //
// ./src/js/pages/single-posts.js